import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import styled from 'styled-components';
import ReviewsCount from '../components/Reviews/ReviewsCount';
import { colors } from '../style-utilities/variables';

const Div = styled.div`
  .logo-container {
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    background-color: ${colors.primary};
    margin-bottom: 20px;
    padding: 10px;
    @media print {
      -webkit-print-color-adjust: exact;
      color-adjust: exact;
      background-color: ${colors.primary};
      margin-bottom: 20px;
      padding: 10px;
    }
  }
`;

class RecipeDetailPrint extends Component {
  componentDidMount() {}

  renderInstruction = () => {
    if (this.props.data.acf.instructions) {
      const instructionList = this.props.data.acf.instructions.map(
        (step, index) => (
          <tr key={step.step} style={{ padding: '5px' }}>
            <td style={{ padding: '5px' }}>
              <span style={{ padding: 0, fontWeight: 'bold' }}>
                Step {index + 1}:{' '}
              </span>
              <p style={{ padding: 0, display: 'inline' }}>
                {ReactHtmlParser(step.step)}
              </p>
            </td>
          </tr>
        )
      );
      return (
        <table>
          <tbody>{instructionList}</tbody>
        </table>
      );
    }
  };

  renderIngredients = () => {
    if (this.props.data.acf.ingredient_products) {
      const ingredientList = this.props.data.acf.ingredient_products.map(
        ingredient => {
          return (
            <li
              id="ingredient-row"
              key={ReactHtmlParser(ingredient.basic_ingredient)}
              style={{
                paddingTop: '10px',
                paddingLeft: 0
              }}
            >
              {ReactHtmlParser(ingredient.basic_ingredient)}
            </li>
          );
        }
      );
      return (
        <table>
          <tbody>{ingredientList}</tbody>
        </table>
      );
    }
  };

  render() {
    return (
      <Div>
        <table cellPadding="10">
          <tbody>
            <tr valign="top">
              <td>
                <img
                  src={
                    this.props.data.acf.thumbnail !== null
                      ? this.props.data.acf.thumbnail.source_url
                      : ''
                  }
                  alt={this.props.data.title ? this.props.data.title : ''}
                  width="320"
                  height="180"
                />
                <br />
                <br />
                <h3 style={{ paddingBottom: '0px' }}>Ingredients</h3>
                <ul className="ingredient-list" style={{ paddingLeft: '10px' }}>
                  {this.renderIngredients()}
                </ul>
              </td>
              <td>
                <div className="logo-container">
                  <img
                    src={this.props.siteLogo}
                    alt={this.props.siteLogo}
                    width="150"
                    height="auto"
                  />
                </div>
                <h2
                  style={{
                    paddingTop: '0px',
                    marginTop: '0px'
                  }}
                >
                  {ReactHtmlParser(
                    this.props.data.title ? this.props.data.title : ''
                  )}
                </h2>
                <p>
                  {ReactHtmlParser(
                    this.props.data.content ? this.props.data.content : ''
                  )}
                </p>
                {/* <ul style={{ paddingBottom: 0, paddingTop: 0 }}>
                  <li>
                    Prep Time:{' '}
                    {this.props.data.acf.prep_time
                      ? this.props.data.acf.prep_time
                      : '-'}
                  </li>
                  <li>
                    Total Time:{' '}
                    {this.props.data.acf.total_time
                      ? this.props.data.acf.total_time
                      : '-'}
                  </li>
                  <li>
                    Serves:{' '}
                    {this.props.data.acf.number_served
                      ? this.props.data.acf.number_served
                      : '-'}
                  </li>
                </ul> */}
                {/* <br /> */}
                <h3>Instructions</h3>
                {this.renderInstruction()}
              </td>
            </tr>
          </tbody>
        </table>
      </Div>
    );
  }
}

export default RecipeDetailPrint;
